module.exports = __webpack_public_path__ + "img/qyzh_tsfx.cbcd6e61.svg";